import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = {
  class: "tabsHeader",
  role: "tablist"
}
const _hoisted_4 = ["id", "aria-controls", "aria-selected", "tabindex", "onClick", "onKeydown"]

import { provide, ref, useSlots, computed, nextTick } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    initialTab: {}
  },
  emits: ['tabChange'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const slots = useSlots();
const tabTitles = computed(() =>
  slots.default ? slots.default().map((tab) => tab.props?.title || '') : []
);

const getInitialTab = () => {
  if (props.initialTab) {
    const match = tabTitles.value.find(
      (title) => title.toLowerCase() === props.initialTab?.toLowerCase()
    );
    if (match) return match;
  }
  return tabTitles.value[0];
};

const selectedTitle = ref(getInitialTab());
const focusedTitle = ref(selectedTitle.value);

provide('SelectedTitle', selectedTitle);

function selectTab(title: string) {
  selectedTitle.value = title;
  focusedTitle.value = title;
  emit('tabChange', title.toLowerCase());
  nextTick(() => {
    const tab = document.getElementById(`tab-${title}`);
    tab?.focus();
  });
}

function focusTab(title: string) {
  focusedTitle.value = title;
  nextTick(() => {
    const tab = document.getElementById(`tab-${title}`);
    tab?.focus();
  });
}

function onKeyDown(event: KeyboardEvent, currentTitle: string) {
  const index = tabTitles.value.indexOf(currentTitle);
  const max = tabTitles.value.length - 1;
  let nextIndex = index;

  switch (event.key) {
    case 'ArrowRight':
      nextIndex = index + 1 > max ? 0 : index + 1;
      focusTab(tabTitles.value[nextIndex]);
      event.preventDefault();
      break;
    case 'ArrowLeft':
      nextIndex = index - 1 < 0 ? max : index - 1;
      focusTab(tabTitles.value[nextIndex]);
      event.preventDefault();
      break;
    case 'Home':
      nextIndex = 0;
      focusTab(tabTitles.value[nextIndex]);
      event.preventDefault();
      break;
    case 'End':
      nextIndex = max;
      focusTab(tabTitles.value[nextIndex]);
      event.preventDefault();
      break;
    case 'Enter':
    case ' ':
      selectTab(currentTitle);
      event.preventDefault();
      break;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabTitles.value, (title) => {
            return (_openBlock(), _createElementBlock("button", {
              key: title,
              role: "tab",
              id: `tab-${title}`,
              "aria-controls": `panel-${title}`,
              "aria-selected": selectedTitle.value === title,
              tabindex: focusedTitle.value === title ? 0 : -1,
              class: _normalizeClass(["tabsItem", { panelActive: selectedTitle.value === title }]),
              onClick: ($event: any) => (selectTab(title)),
              onKeydown: ($event: any) => (onKeyDown($event, title))
            }, _toDisplayString(title), 43, _hoisted_4))
          }), 128))
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}
}

})